// A day the system closed because nobody checked out, set right by the
// person's direct manager or HR (owner, 2026-10-13). The server holds every
// rule: 20261013100000_fix_auto_closed_day.sql (fix_auto_closed_day,
// auto_closed_days_to_fix). Nothing here grants anything.
import { supabase } from './supabase';

export type AutoClosedDay = {
  entry_id: string;
  profile_id: string;
  full_name: string | null;
  /** The org day, 'YYYY-MM-DD'. */
  work_date: string;
  /** When they checked in (ISO). */
  check_in: string;
  /** When the system closed it (ISO). */
  check_out: string | null;
  seconds: number;
};

/** Your direct reports' auto-closed days you can still fix. A failed read is
 *  not an empty list (UI-CONVENTIONS §7). */
export async function listDaysToFix(): Promise<{
  data: AutoClosedDay[];
  error: { message: string } | null;
}> {
  if (!supabase) return { data: [], error: null };
  try {
    const { data, error } = await supabase.rpc('auto_closed_days_to_fix');
    return { data: (data as AutoClosedDay[] | null) ?? [], error };
  } catch (e) {
    // A dropped connection rejects instead of returning an error: same answer.
    return { data: [], error: { message: (e as Error).message || 'network error' } };
  }
}

/** Times are org-local 'HH:MM'; the server turns them into hours less breaks. */
export async function fixAutoClosedDay(args: {
  entryId: string;
  checkIn: string;
  checkOut: string;
  reason: string;
}): Promise<{ error: { message: string } | null }> {
  if (!supabase) return { error: { message: 'Not connected.' } };
  const { error } = await supabase.rpc('fix_auto_closed_day', {
    p_entry: args.entryId,
    p_check_in: args.checkIn,
    p_check_out: args.checkOut,
    p_reason: args.reason,
  });
  return { error };
}
